import { render } from "./TablaServiciosColectivosSolicitados.vue?vue&type=template&id=590af10b&ts=true"
import script from "./TablaServiciosColectivosSolicitados.vue?vue&type=script&lang=ts"
export * from "./TablaServiciosColectivosSolicitados.vue?vue&type=script&lang=ts"

import "./TablaServiciosColectivosSolicitados.vue?vue&type=style&index=0&id=590af10b&lang=css"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__